module.exports = __webpack_public_path__ + "static/media/bank-of-ireland.f744aa94.png";